import { Component, Input, OnChanges } from "@angular/core";
import { Chart, registerables } from "chart.js/auto";
import { ObservationResponseAllDto } from "../../../../../common/dtos/observation/observation.response.all";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables, ChartDataLabels);
@Component({
  selector: "app-origin-chart",
  templateUrl: "./origin-chart.component.html",
  styleUrls: [
    "./origin-chart.component.scss"
  ]
})
export class OriginChartComponent implements OnChanges {
  public originChart: Chart | null = null;
    @Input() data: ObservationResponseAllDto | undefined;

    ngOnChanges(): void {
      if (this.data) {
        this.createChart(this.data);
      }
    }

    createChart(result: ObservationResponseAllDto) {
      const originCounts: { [key: string]: number } = {};
      result.content.forEach((item) => {
        const origin = item.origin;
        if (originCounts[origin!]) {
          originCounts[origin!]++;
        } else {
          originCounts[origin!] = 1;
        }
      });

      const labelsOrigin = Object.keys(originCounts);
      const valuesOrigin = Object.values(originCounts);
      const total = valuesOrigin.reduce((sum, val) => sum + val, 0);

      if (this.originChart) {
        this.originChart.destroy();
      }

      this.originChart = new Chart("OriginChart", {
        type: "doughnut",
        data: {
          labels: labelsOrigin,
          datasets: [
            {
              label: "Origin",
              data: valuesOrigin,
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
                "rgb(61, 212, 94)"
              ],
              hoverOffset: 4
            }
          ]
        },
        options: {
          aspectRatio: 2.5,
          plugins: {
            tooltip: {
              callbacks: {
                label(tooltipItem) {
                  const value = tooltipItem.raw as number;
                  const percentage = ((value / total) * 100).toFixed(1);
                  return `${value} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    }
}
